export const germanHeaderTranslations: { [key: string]: string } = {
  Titel: "Title",
  Benutzername: "Username",
  Konto: "Account",
  Passwort: "Password",
  "Geändert am": "Modified",
  "Erstellt am": "Created",
  "Läuft ab am": "Expire on",
  Beschreibung: "Description",
  "Geändert von": "Modified by",
};
